export const ACCESS_GROUPS_PATH = '/access-groups'

export const getGroupPath = (groupType, id) => `${ACCESS_GROUPS_PATH}?${new URLSearchParams({ tab: groupType, id })}`
